<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="430px"
    @keydown.esc="closeDialog"
  >
    <v-card v-if="defaultMeeting">
      <div
        style="
          display: flex;
          justify-content: space-between;
          align-items: center;
          height: 60px;
        "
        v-if="meeting"
      >
        <div class="popup-title">회의 상세정보</div>
        <!-- <div style="display: flex; flex-direction: row; align-items:center;">
          <img
            v-if="
              meeting.creator.email === $store.state.user.email &&
                meeting.status === 's'
            "
            @click="openDeleteConfirmDialog('close')"
            src="../../../src/images/button/closevideo.png"
            style="width:26px; height: 26px; margin-right:10px; cursor: pointer;"
          />
          <img
            v-if="meeting.creator.email === $store.state.user.email"
            @click="openDeleteConfirmDialog('del')"
            src="../../../src/images/button/delBtn.png"
            style="margin-right:20px; cursor: pointer; width: 26px;"
          />
        </div> -->
      </div>
      <div class="dialog-body detailTable" v-if="meeting" style="margin-top: 0">
        <table>
          <colgroup>
            <col style="width: 120px" />
            <col style="width: 290px" />
          </colgroup>
          <tbody>
            <tr>
              <th>
                <span>회의 제목</span>
              </th>
              <td class="name">
                {{ meeting.title }}
              </td>
            </tr>
            <tr>
              <th>
                <span>회의 일시</span>
              </th>
              <td>
                {{ meeting.startDtime | formatDate3 }}&nbsp; &nbsp;
                {{ meeting.startDtime | formatTime }} -
                {{ meeting.endDtime | formatTime }}
              </td>
            </tr>
            <tr>
              <th>
                <span>회의 번호</span>
              </th>
              <td>
                <span>{{ meeting.meetingKey }} </span>
                <img
                  style="
                    width: 24px;
                    position: relative;
                    top: 5px;
                    margin-left: 10px;
                    cursor: pointer;
                  "
                  @click="clipboard"
                  src="../../../src/images/button/copy.png"
                />
              </td>
            </tr>
            <tr>
              <th>
                <span>개설자</span>
              </th>
              <td>
                {{ meeting.creator ? meeting.creator.name : null }}
                <span
                  v-if="meeting.creator"
                  style="font-size: 10.5pt; margin-left: 5px"
                  >&nbsp;({{ meeting.creator.deptFullName }})</span
                >
              </td>
            </tr>
            <tr>
              <th>
                <span>참석자</span>
              </th>
              <td>
                <ul
                  v-for="(attendee, index) in attendees"
                  v-bind:item="attendee"
                  v-bind:index="index"
                  v-bind:key="attendee.email"
                >
                  <li style="display: flex; align-items: center">
                    {{
                      attendee.name
                        ? attendee.name
                        : attendee.email
                        ? attendee.email
                        : attendee.phone
                    }}
                    <span
                      v-if="attendee.DEPT_NM"
                      style="
                        font-size: 10.5pt;
                        margin-left: 5px;
                        word-spacing: 5px;
                      "
                      >({{ attendee.DEPT_NM }})</span
                    >
                  </li>
                </ul>
              </td>
            </tr>
            <tr v-if="meeting.conferenceRooms.length >= 1">
              <th>
                <span>회의실</span>
              </th>
              <td>
                <ul
                  v-for="(attendee, index) in meeting.conferenceRooms"
                  v-bind:item="attendee"
                  v-bind:index="index"
                  v-bind:key="attendee.email"
                >
                  <li style="display: flex; align-items: center; margin: 5px 0">
                    {{ attendee.deviceName }}
                    <!-- <img
                      v-if="meeting.status == 's' && meeting.conferenceRoomActive === true"
                      style="width: 20px; cursor: pointer; margin-left: 10px;"
                      src="../../../src/images/button/telephone.png"
                      @click="recall(meeting, attendee)"
                    /> -->
                  </li>
                </ul>
              </td>
            </tr>
            <tr>
              <th>
                <span>부가기능</span>
              </th>
              <td>
                <div v-if="meeting.meetingLog">실시간 자막</div>
                <div
                  v-if="meeting.allPublicMeeting"
                  style="display: flex; align-items: center"
                >
                  <span>전체 공개회의</span>
                </div>
                <div>
                  {{ meeting.isPrivate === true ? '비밀번호 설정' : '' }}
                </div>
                <div v-if="meeting.exMeeting">인터넷망 전용 회의</div>
              </td>
            </tr>

            <tr
              v-if="
                meeting.layout.isLayout &&
                meeting.conferenceRoomActive === false
              "
            >
              <th>
                <span>레이아웃</span>
              </th>
              <td style="padding-top: 10px">
                <img
                  id="bookmarkImage"
                  style="width: 100px; float: left"
                  :src="meeting.layout.selectedLayoutImage"
                />
                <ul
                  id="bookmarkFixLayout"
                  style="
                    padding: 0;
                    border: none;
                    float: left;
                    margin-left: 10px;
                  "
                  v-if="meeting.layout.fixSeatList !== null"
                >
                  <li style="font-weight: bold">자리지정</li>
                  <li
                    class="fix-seat-list"
                    v-for="(attendee, index) in meeting.layout.fixSeatList"
                    v-bind:item="attendee"
                    v-bind:index="index"
                    v-bind:key="attendee.seat.key"
                  >
                    <span v-if="attendee.seat.key !== null"
                      >#{{ index + 1 }} : {{ attendee.seat.name }}</span
                    >
                  </li>
                </ul>
              </td>
            </tr>
            <tr v-if="this.$store.state.user.email === meeting.creator.email">
              <th>
                <span>문항작성</span>
              </th>
              <td
                v-if="
                  meeting.isSurvey === false || meeting.isSurvey === undefined
                "
              >
                <button @click="createSurvey(meeting.meetingKey)">
                  작성하기
                </button>
              </td>
              <td v-else-if="meeting.isSurvey === true">
                <button @click="editSurvey(meeting.meetingKey)">수정</button>
                <button @click="deleteSurvey(meeting.meetingKey)">삭제</button>
                <button @click="resultSurvey(meeting.meetingKey)">
                  결과보기
                </button>
              </td>
            </tr>
            <tr v-else>
              <th>
                <span>문항참여</span>
              </th>
              <td v-if="meeting.isSurvey === true">
                <button @click="joinSurvey(meeting.meetingKey)">
                  참여하기
                </button>
              </td>
              <td v-else>-</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="btnArea">
        <button class="btnPrimary" @click="closeDialog">완료</button>
      </div>
    </v-card>
    <!-- 회의 저장 -->
    <add-bookmark-meeting-dialog
      :dialog="addBookmarkMeetingDialog.dialog"
      :meetingInfo="addBookmarkMeetingDialog.meetingInfo"
      :closeDialog="closeAddBookmarkMeetingDialog"
    />

    <delete-confirm-dialog
      :dialog="deleteConfirmDialog.dialog"
      :meeting="meeting"
      :checkDelClose="checkDelClose"
      :closeDialog="closeAddBookmarkMeetingDialog"
      :closeDeleteConfirmDialog="closeDeleteConfirmDialog"
    ></delete-confirm-dialog>

    <ksd-survey
      :dialog="createSurveyDialog.dialog"
      :meetingKey="createSurveyDialog.meetingKey"
      :isEdit="editSurveyDialog.isEdit"
      :editSurvey="editSurveyDialog.survey"
      :editSteps="
        editSurveyDialog.meetingKey !== ''
          ? editSurveyDialog.survey.questions.length
          : 1
      "
      :close="closeSurveyDialog"
    >
    </ksd-survey>

    <ksd-survey-viewer
      :dialog="surveyViewer.dialog"
      :survey="surveyViewer.survey"
      :meetingKey="surveyViewer.meetingKey"
      :close="closeSurveyViewerDialog"
      :steps="
        surveyViewer.meetingKey !== ''
          ? surveyViewer.survey.questions.length
          : 1
      "
    />

    <ksd-survey-result
      :dialog="surveyResult.dialog"
      :surveyResult="surveyResult.result"
      :close="closeSurveyResultDialog"
    >
    </ksd-survey-result>

    <!-- <edit-meeting-dialog
      :dialog="editMeetingDialog.dialog"
      :meetingInfo="editMeetingDialog.meeting"
      @editedMeeting="editedMeeting"
    /> -->
    <!-- <all-attendee-dialog
      :dialog="allAttendeeDialog.dialog"
      :attendees="allAttendeeDialog.attendees"
      :closeDialog="closeAllAttendees"
    /> -->
  </v-dialog>
</template>
<script>
import Util from '@/util';
import moment from 'moment';
import BaseModal from '@/components/popup/BaseModal';
import AddBookmarkMeetingDialog from '@/components/popup/AddBookmarkMeetingDialog';
import DeleteConfirmDialog from '@/components/popup/DeleteConfirmDialog';
import KsdSurvey from '@/components/popup/KsdSurvey';
import ksdSurveyViewer from '@/components/popup/KsdSurveyViewer';
import ksdSurveyResult from '@/components/popup/KsdSurveyResult';

export default {
  components: {
    BaseModal: BaseModal,
    AddBookmarkMeetingDialog,
    DeleteConfirmDialog,
    KsdSurvey,
    ksdSurveyViewer,
    ksdSurveyResult,
  },
  filters: {
    dayConversion: function (time) {
      return moment(time).format('YYYY.MM.DD');
    },
    timeConversion: function (time) {
      return moment(time).format('HH:mm');
    },
    departmentConversion: function (department) {
      switch (department) {
        case 'businessSales':
          department = '영업부';
          break;
        case 'businessManage':
          department = '경영기획';
          break;
        case 'lab':
          department = '연구소';
          break;
      }

      return department;
    },
  },
  props: ['dialog', 'defaultMeeting', 'isAdmin', 'closeDialog'],
  data() {
    return {
      meeting: {},
      surveyResult: {
        dialog: false,
        result: [],
      },
      editSurveyDialog: {
        dialog: false,
        survey: {
          questions: [],
        },
        meetingKey: '',
        isEdit: false,
      },
      surveyViewer: {
        dialog: false,
        survey: {
          questions: [],
        },
        meetingKey: '',
      },
      recordStatus: {
        status: 'on',
        count: 0,
        image: '/static/images/button/rec-button-on.png',
      },
      loading: true,
      checkDelClose: 'del',
      conferenceRoomsString: null,
      deviceList: [],
      attendees: [],
      allPublicStatus: 'public',
      conStyle: {
        conferenceTitleW: 22,
        conferenceCreatorW: 8,
        conferenceDateW: 33,
        conferenceJoinNumW: 17,
        conferenceCreatorKeyW: 10,
        conferencePasswordW: 10,
      },
      addBookmarkMeetingDialog: {
        dialog: false,
        meetingInfo: {},
      },
      deleteConfirmDialog: {
        dialog: false,
      },
      createSurveyDialog: {
        dialog: false,
        meetingKey: '',
      },
      editMeetingDialog: {
        dialog: false,
        meeting: {},
      },
      allAttendeeDialog: {
        dialog: false,
        attendees: [],
      },
      allConferenceRoomDialog: {
        dialog: false,
        rooms: [],
      },
      isCreator: false,
    };
  },
  computed: {
    computeLogo() {
      return '/static/images/info_icon.png';
    },
  },
  watch: {
    dialog: {
      async handler(val) {
        if (val) {
          this.meeting = Object.assign({}, this.defaultMeeting);
          await this.initMeetingList();
          // this.checkHost();
        }
      },
    },
    // allPublicStatus: {
    //   async handler (val) {
    //     console.log(val);
    //     await this.updatePublicMeetingStatus(this.meeting.meetingKey, val);
    //   },
    // },
  },
  mounted() {
    this.loading = false;
  },
  methods: {
    async updatePublicMeetingStatus(meetingKey, status) {
      console.log(`updatePublicMeetingStatus : `, meetingKey);
      let json = {
        status: status,
        meetingKey: meetingKey,
      };
      await this.$http
        .put('/api/v1/meetings/updatePublicMeetingStatus', json)
        .then((response) => {
          console.log(response);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async deleteMeeting() {
      this.deleteConfirmDialog.dialog = true;
      this.checkDelClose = 'del';

      let params = {
        meetingKey: this.meeting.meetingKey,
        meetingType: this.meeting.meetingType,
        creator: this.meeting.creator,
        email: this.meeting.creator.email,
      };

      await this.$http
        .post('/api/v1/meetings/deleteKrxMeeting', params)
        .then((response) => {
          if (response) {
            if (response.data.fail) {
              alert(
                '차량/회의실 연동 오류 - 스마트회의 내 영상회의실 삭제 완료',
              );
              this.closeDialog('delete');
            } else {
              Util.snackBarOpen('영상회의 삭제 완료', 'success');
              this.closeDialog('delete');
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    openDeleteConfirmDialog(txt) {
      this.deleteConfirmDialog.dialog = true;
      this.checkDelClose = txt;
    },
    async closeMeeting() {
      let params = {
        meetingKey: this.meeting.meetingKey,
        meetingType: this.meeting.meetingType,
        creator: this.meeting.creator,
        email: this.meeting.creator.email,
      };

      await this.$http
        .delete('/api/v1/meetings/closeKrxMeeting', { params: params })
        .then((response) => {
          if (response) {
            this.closeDialog('delete');
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    clipboard() {
      this.$copyText(this.meeting.meetingKey).then(() => {
        Util.snackBarOpen(this.$t('미팅키가 복사되었습니다.'), 'success');
      });

      // window.navigator.clipboard.writeText(this.meeting.meetingKey);
    },
    async recall(meeting, device) {
      let body = {
        meeting: meeting,
        device: device,
      };

      await this.$http
        .post('/api/v1/meetings/oneDeviceCall', body)
        .then((response) => {
          console.log(response.data);
          if (response.data === true) {
            alert('영상회의실이 재호출 되었습니다.');
          } else {
            alert(
              '영상회의실 연결에 실패했습니다. 회의실 상태를 확인 바랍니다.',
            );
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async startRecord(meeting) {
      let body = {
        meeting: meeting,
        // recording: meeting.recordCheck ? false : true,
        recording: true,
        count: this.recordStatus.count + 1,
      };

      await this.$http
        .post('/api/v1/meetings/setRecordStatus', body)
        .then((response) => {
          if (response) {
            alert('고화질 영상회의 녹화가 시작되었습니다.');
            // if (response.data.recordCheck) {
            //   alert("고화질 영상회의 녹화가 시작되었습니다.");
            //   this.recordStatus.image =
            //     "/static/images/button/rec-button-on.png";
            // } else {
            //   alert("고화질 영상회의 녹화가 종료되었습니다.");
            //   this.recordStatus.image = "/static/images/button/rec-button.png";
            //   this.recordStatus.count = response.data.recordCount;
            // }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    async addPeople() {
      /* 추가초대 버튼 Func */
      console.log('addPeople');
    },
    async initMeetingList() {
      this.attendees = this.meeting.attendees;
      if (this.meeting.conferenceRooms) {
        this.meeting.conferenceRooms.forEach((el) => {
          this.conferenceRoomsString += el.deviceName + ' / ';
        });
      }
      this.allPublicStatus = this.meeting.publicMeetingStatus;
    },
    checkHost() {
      if (this.$store.state.user.email === this.meeting.creator.email) {
        this.isCreator = true;
      } else {
        this.isCreator = false;
      }
    },
    showAllAttendees(attendees) {
      this.allAttendeeDialog.dialog = true;
      this.allAttendeeDialog.attendees = attendees;
    },
    closeAllAttendees() {
      this.allAttendeeDialog.dialog = false;
      this.allAttendeeDialog.attendees = [];
    },
    showAllConferenceRoom(meetingRoom) {
      this.allConferenceRoomDialog.dialog = true;
      this.allConferenceRoomDialog.rooms = meetingRoom;
    },
    closeAllConferenceRoom() {
      this.allConferenceRoomDialog.dialog = false;
      this.allConferenceRoomDialog.rooms = [];
    },
    editMeeting(meeting) {
      this.editMeetingDialog.dialog = true;
      this.editMeetingDialog.meeting = meeting;
    },
    editedMeeting() {
      this.editMeetingDialog.dialog = false;
      this.$emit('editedMeeting');
    },
    openAddBookmarkMeetingDialog(meeting) {
      console.log(`bookmarkMeeting : `, meeting);

      this.addBookmarkMeetingDialog.dialog = true;

      this.addBookmarkMeetingDialog.meetingInfo = meeting;
    },
    closeAddBookmarkMeetingDialog() {
      this.addBookmarkMeetingDialog.dialog = false;
      this.deleteConfirmDialog.dialog = false;
    },
    closeDeleteConfirmDialog() {
      let checkDelClose = this.checkDelClose;
      if (checkDelClose === 'del') {
        this.deleteMeeting();
      } else {
        this.closeMeeting();
      }
      this.deleteConfirmDialog.dialog = false;
    },
    createSurvey(meetingKey) {
      this.createSurveyDialog.dialog = true;
      this.createSurveyDialog.meetingKey = meetingKey;

      this.editSurveyDialog.meetingKey = '';
      this.editSurveyDialog.isEdit = false;
      this.editSurveyDialog.survey = {};
    },
    async closeSurveyDialog() {
      this.createSurveyDialog.dialog = false;
      let params = {
        meetingKey: this.meeting.meetingKey,
      };
      await this.$http
        .get('/api/v1/meetings', { params: params })
        .then((response) => {
          if (response) {
            this.meeting = response.data[0];

            this.editSurveyDialog.meetingKey = '';
            this.editSurveyDialog.isEdit = false;
            this.editSurveyDialog.survey = {};
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async closeSurveyResultDialog() {
      this.surveyResult.dialog = false;
    },
    async joinSurvey(meetingKey) {
      let params = {
        meetingKey: meetingKey,
      };
      await this.$http
        .get('/api/v1/surveys', { params: params })
        .then((response) => {
          if (response) {
            console.log(response.data);
            this.surveyViewer.survey = response.data[0];
            this.surveyViewer.meetingKey = meetingKey;
            this.surveyViewer.dialog = true;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async editSurvey(meetingKey) {
      let params = {
        meetingKey: meetingKey,
      };
      await this.$http
        .get('/api/v1/surveys', { params: params })
        .then((response) => {
          console.log(response.data[0]);
          this.createSurveyDialog.dialog = true;
          this.editSurveyDialog.isEdit = true;
          this.editSurveyDialog.meetingKey = meetingKey;
          this.editSurveyDialog.survey = response.data[0];
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async deleteSurvey(meetingKey) {
      if (confirm('문항을 삭제하시겠습니까?')) {
        let params = {
          meetingKey: meetingKey,
        };
        await this.$http
          .post('/api/v1/surveys/deleteSurvey', params)
          .then((response) => {
            if (response) {
              alert('문항이 삭제되었습니다.');
              this.meeting.isSurvey = false;
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    async resultSurvey(meetingKey) {
      let params = {
        meetingKey: meetingKey,
      };
      await this.$http
        .get('/api/v1/surveys/resultSurveys', { params: params })
        .then((response) => {
          console.log(response.data[0]);
          this.surveyResult.dialog = true;
          this.surveyResult.result = response.data[0];
        })
        .catch((error) => {
          console.log(error);
        });
    },
    closeSurveyViewerDialog() {
      this.surveyViewer.dialog = false;
    },
  },
};
</script>
<style scoped>
.popup_top {
  padding-left: 0;
  background-color: #efeefd;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.popup-title {
  line-height: 77px;
  color: #333333;
  font-weight: 700;
  font-size: 16px;
  padding-left: 24px;
}
.dataTable table td:nth-child(odd) {
  background: #fff;
  width: 145px;
  padding-left: 40px;
}

.dataTable table.info td:nth-child(odd) {
  background: #fff;
  padding-left: 0px;
}

.dataTable table.detail td:nth-child(2n) {
  font-family: 'Noto Sans KR';
  font-style: normal;
  font-weight: 300;
  font-size: 18px;
  color: #333;
  vertical-align: top;
}

.dataTable table td {
  height: 66px;
  background: #fff;
  letter-spacing: -2px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  font-family: 'Noto Sans KR';
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  color: #333;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  position: relative;
  vertical-align: middle;
}

.v-dialog {
  max-height: none !important;
}

.btnArea {
  display: flex;
  justify-content: center;
}

.invite-btn {
  background-color: #604af3;
  color: white;
  width: 130px;
  height: 48px;
  border-radius: 8px;
  margin: 0 5px;
  font-size: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/MeetingInfoDialog.vue